const getAppUISizeFromEnvs = () => import.meta.env.VITE_APP_UI_SIZE

export default getAppUISizeFromEnvs
